import { makeStyles, Theme } from "@material-ui/core";
import { tesaBlue, tesaGrey1, tesaGrey4 } from "../../styles/colors";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    "& div.MuiTabScrollButton-root": {
      width: 12,
    },
    "& div.MuiTabs-scroller": {
      "& .MuiTabs-flexContainer": {
        display: "inline",
      },
    },
    margin: theme.spacing(3),
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  paddingInset: {
    color: tesaGrey1,
    backgroundColor: "white",
  },
  tab: {
    minWidth: 200,
  },
  tabIcon: {
    color: tesaGrey4,
    height: "16px",
    width: "16px",
    "&:hover": {
      color: tesaBlue,
      cursor: "pointer",
    },
  },
  tabPanelContainer: {
    "& div.MuiBox-root": {
      padding: `${theme.spacing(1)}px 0px ${theme.spacing(1)}px 0px`,
    },
  },
  assignmentSubHeader: {
    display: "block",
    fontSize: "1rem",
    fontWeight: "bold",
    lineHeight: "1.5rem",
  },
  assignmentSubtitle: {
    ...theme.typography.subtitle2,
  },
}));

export default useStyles;
